// extracted by mini-css-extract-plugin
export default {"header":"PropertyIntroduction_header__daE-K","infoContainer":"PropertyIntroduction_infoContainer__xtpUN"};